<template>
  <div>
    <v-progress-linear
      v-if="loading && !dishes"
      indeterminate
      color="rgb(86, 160, 153)"
      style="margin-top:20px;"
    />
    <v-data-table
      :headers="headers"
      :items="dishes"
      sort-by="calories"
      class="elevation-1"
      v-if="dishes"
      :items-per-page="itemsPerPage"
      :loading="loading"
      hideDefaultFooter
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>{{$t('dishes.title')}}</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <!-- <v-spacer /> -->
          <v-btn v-if="dishes" @click="handleExportToPDF"><v-icon>mdi-file-pdf</v-icon></v-btn>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-select
            solo
            :label="$t('menus.name')"
            v-if="menusFilter"
            v-model="menuFilterSelected"
            :items="menusFilter"
            item-text="Name"
            item-value="ID"
            style="margin-top:30px;margin-right: 5px;"
            @change="handleChangeFilterSelected"
          />
          <v-text-field
            solo
            :label="$t('common.search')"
            append-icon="mdi-magnify"
            style="margin-top:30px;"
            v-model="search"
            @input="handleSearch"
          />
          <v-spacer /> 
          <form-dishes :dialog="dialog" :data="editedItem" 
            :onSave="handleSave"
            :onClose="handleClose"
          />
          <!-- <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.name" label="Dessert name"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.calories" label="Calories"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.fat" label="Fat (g)"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.carbs" label="Carbs (g)"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.protein" label="Protein (g)"></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog> -->
        </v-toolbar>
      </template>
      <template v-slot:item.HideMobile="{ item }">
        <center>
          <v-icon v-if="item.HideMobile" @click="handleChangeHideAll(item.MenuContentID, false)">mdi-eye-off</v-icon>
          <v-icon v-else  @click="handleChangeHideAll(item.MenuContentID, true)">mdi-eye</v-icon>
        </center>
      </template>
      <template v-slot:item.FoodVegan="{ item }">
        <center>
          <v-checkbox
            v-model="item.FoodVegan"
            :value="item.FoodVegan"
            @change="handleChangeVegan(item)"
          />
        </center>
      </template>
      <template v-slot:item.FoodVegetarian="{ item }">
        <center>
          <v-checkbox
            v-model="item.FoodVegetarian"
            :value="item.FoodVegetarian"
            @change="handleChangeVegetarian(item)"
          />
        </center>
      </template>
      <template v-slot:item.FoodNew="{ item }">
        <center>
          <v-checkbox
            v-model="item.FoodNew"
            :value="item.FoodNew"
            @change="handleChangeNew(item)"
          />
        </center>
      </template>
      <template v-slot:item.FoodRecommended="{ item }">
        <center>
          <v-checkbox
            v-model="item.FoodRecommended"
            :value="item.FoodRecommended"
            @change="handleChangeRecommended(item)"
          />
        </center>
      </template>
      <template v-slot:item.FoodAllergens="{ item }">
          <span
            v-for="(allergen, indexRows) in item.FoodAllergens"
            :key="`rows${indexRows}`"
          >{{ indexRows > 0 ? ', ' : ''}}{{getAllergenFormatted(allergen)}}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          @click="handleDeleteItem(item.MenuContentID)"
        >
          mdi-delete
        </v-icon>
      </template>
      <!-- <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template> -->
    </v-data-table>
    <v-layout wrap>
      <v-flex xs2>
        <v-select
            solo
            :label="$t('common.show')"
            v-model="itemsPerPage"
            :items="[
              { ID: 100000, Name: 'All'},
              { ID: 5, Name: '5'},
              { ID: 10, Name: '10'},
              { ID: 25, Name: '25'},
            ]"
            item-text="Name"
            item-value="ID"
            @change="getDishes"
            style="margin: 5px;"
          />
      </v-flex>
      <v-flex xs10 
        v-if="pageCount > 0"
        style="padding-left: 10px;padding-right: 10px;"
      >
        <v-pagination
          v-model="page"
          :length="pageCount"
          @input="handleChangePage"
        />
      </v-flex>
    </v-layout>
    
  </div>
</template>

<script>
  import jsPDF from 'jspdf'
  import 'jspdf-autotable'
  import _ from 'lodash'
  import api from '@/services/api'
  import utils from '@/services/utils'
  import i18n from '@/plugins/i18n'
  import FormDishes from './FormDishes'
  export default {
    components: {
      FormDishes
    },
    data: () => ({
      menusFilter: [],
      menuFilterSelected: null,
      page: 1,
      loading: false,
      search: '',
      dialog: false,
      itemsPerPage: 10,
      allergens: null,
      pageCount: 0,
      headers: [
        {
          text: '',
          align: 'start',
          sortable: true,
          value: 'HideMobile',
        },
        {
          text: i18n.t('dishes.menu'),
          align: 'start',
          sortable: true,
          value: 'MenuNameFormatted',
        },
        {
          text: i18n.t('dishes.food'),
          align: 'start',
          sortable: true,
          value: 'FoodNameFormatted',
        },
        {
          text: i18n.t('dishes.ingredients'),
          align: 'start',
          sortable: true,
          value: 'FoodIngredientsFormatted',
        },
        {
          text: i18n.t('dishes.price'),
          align: 'start',
          sortable: true,
          value: 'FoodPrice',
        },
        {
          text: i18n.t('dishes.vegan'),
          align: 'start',
          sortable: true,
          value: 'FoodVegan',
        },
        {
          text: i18n.t('dishes.vegetarian'),
          align: 'start',
          sortable: true,
          value: 'FoodVegetarian',
        },
        {
          text: i18n.t('food.new'),
          align: 'start',
          sortable: true,
          value: 'FoodNew',
        },
        {
          text: i18n.t('food.recommended'),
          align: 'start',
          sortable: true,
          value: 'FoodRecommended',
        },
        { text: i18n.t('dishes.allergens'), value: 'FoodAllergens' },
        // { text: 'Calories', value: 'calories' },
        // { text: 'Fat (g)', value: 'fat' },
        // { text: 'Carbs (g)', value: 'carbs' },
        // { text: 'Protein (g)', value: 'protein' },
        { text: '', value: 'actions', sortable: false },
      ],
      dishes: null,
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
        FoodAllergens: []
      },
    }),
    computed: {
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      locale () {
        return i18n.locale
      },
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
      // pageCount () {
      //   let page = this.count > 0 ? parseInt(this.count / this.itemsPerPage, 10) : 0
      //   if (this.count > 0 && (this.count % this.itemsPerPage)!== 0) page++
      //   return page
      // },
    },

    watch: {
      dialog (val) {
        val || this.handleClose()
      },
      enterpriseID (newValue, oldValue) {
        if (oldValue !== newValue && newValue) this.getMenusFilter ()
      }
    },

    // created () {
    //   this.initialize()
    // },
    mounted () {
      if (this.enterpriseID) this.getMenusFilter ()
      this.loading = true
      this.handleSearch = _.debounce(() => {
        this.getDishes()        
      }, 500)
      this.initialize()
    },
    methods: {
      getMenusFilter () {
        api.getAll(`contents/${this.enterpriseID}/dishes-menu`, true).then(response => {
          this.menusFilter = response.map(item => {
            item.Name = utils.getTranslation(JSON.parse(item.Name), this.locale) 
            return item
          })
          this.menusFilter.unshift({
            ID: '',
            Name: ''
          })
        })
      },
      initialize () {   
        const enterpriseIDDomain = this.$store.state.app.enterpriseID ? this.$store.state.app.enterpriseID : utils.getDomain()
        api.getItem('utils', true, `allergens/${enterpriseIDDomain}`).then(response => {     
          this.allergens = response.data.map(item => {
            item.Name = utils.getTranslation (item.Name, this.locale) 
            return item
          })
          this.getDishes()
        })
      },
      getDishes() {
        this.loading = true
        const aux = this.menuFilterSelected && this.menuFilterSelected.length > 0 ? this.itemsPerPage.toString().concat('&menuFilter=', this.menuFilterSelected) : this.itemsPerPage
        api.getAll(`contents/${this.enterpriseID}/dishes`, true, this.page, aux, this.search).then(response => {
          this.loading = false   
          if (response.count) {
            this.count = response.count
            let page = this.count > 0 ? parseInt(this.count / this.itemsPerPage, 10) : 0
            if (this.count > 0 && (this.count % this.itemsPerPage)!== 0) page++
            this.pageCount = page
          }
          
          this.dishes = response.data.map( item => {
            item.MenuName = JSON.parse(item.MenuName)
            item.FoodName = JSON.parse(item.FoodName)
            item.FoodIngredients = JSON.parse(item.FoodIngredients)
            item.FoodAllergens = JSON.parse(item.FoodAllergens)
            item.MenuNameFormatted = utils.getStringETC(utils.getTranslation(item.MenuName, this.locale), 40)
            item.FoodNameFormatted = utils.getStringETC(utils.getTranslation(item.FoodName, this.locale), 40)
            item.FoodIngredientsFormatted = utils.getStringETC(utils.getTranslation(item.FoodIngredients, this.locale), 40)
            return item
          })
          // this.onSearch()
        })    
      },
      onSearch () {
        if (this.search.length > 0) {
          this.dishesFiltered = this.dishes.filter(x => 
            JSON.stringify(x.MenuName).toUpperCase().indexOf(this.search.toUpperCase()) >= 0 ||
            JSON.stringify(x.FoodName).toUpperCase().indexOf(this.search.toUpperCase()) >= 0 ||
            JSON.stringify(x.FoodIngredients).toUpperCase().indexOf(this.search.toUpperCase()) >= 0
          )
        } else {
          this.dishesFiltered = this.dishes
        }
      },
      getAllergenFormatted (value) {
        return this.allergens.filter(x => x.ID === value)[0].Name
        // const aux = this.allergens.map (item => {
        //   if (item.ID.split('/').length > 1) item.ID = item.ID.split('/')[1]
        //   return item
        // })
        // let auxValue = value
        // if (auxValue.split('/').length > 1) auxValue = auxValue.split('/')[1]
        // return aux.filter(x => x.ID === auxValue)[0].Name
      },
      handleChangeHideAll (id, hideMobile) {
        const body = {
          Hide: hideMobile
        }
        api.updateItem('contents', id.concat('/hide-all'), body)
          .then(() => {
            this.getDishes()
          })
        .catch(error => {
          console.log('error', error)
        })
      },
      handleChangeVegan (body) {
        body.FoodVegan = body.FoodVegan ? true : false
        api.updateItem('contents', body.MenuContentID.concat('/dishes'), body)
          .then(() => {
            this.getDishes()
          })
        .catch(error => {
          console.log('error', error)
        })
      },
      handleChangeVegetarian (body) {
        body.FoodVegetarian = body.FoodVegetarian ? true : false
        api.updateItem('contents', body.MenuContentID.concat('/dishes'), body)
          .then(() => {
            this.getDishes()
          })
        .catch(error => {
          console.log('error', error)
        })
      },
      handleChangeNew (body) {
        body.FoodNew = body.FoodNew ? true : false
        api.updateItem('contents', body.MenuContentID.concat('/dishes'), body)
          .then(() => {
            this.getDishes()
          })
        .catch(error => {
          console.log('error', error)
        })
      },
      handleChangeRecommended(body) {
        body.FoodRecommended = body.FoodRecommended ? true : false
        api.updateItem('contents', body.MenuContentID.concat('/dishes'), body)
          .then(() => {
            this.getDishes()
          })
        .catch(error => {
          console.log('error', error)
        })
      },

      editItem (item) {
        this.editedIndex = this.dishes.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      handleDeleteItem (menuContentID) {
        api.deleteItem('contents', menuContentID).then(response => {
            if (response.status === 200) this.getDishes()
          })
        // const index = this.dishes.indexOf(item)
        // confirm('Are you sure you want to delete this item?') && this.dishes.splice(index, 1)
      },

      handleClose () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      handleSave (body) {
        api.updateItem('contents', body.MenuContentID.concat('/dishes'), body)
          .then(() => {
            this.getDishes()
          })
        .catch(error => {
          console.log('error', error)
        })
        this.handleClose()
      },
      handleExportToPDF () {
        const doc = new jsPDF('l')

        // It can parse html:
        // <table id="my-table"><!-- ... --></table>
        doc.autoTable({ html: '#my-table' })

        const body = []
        for (const item of this.dishes) {
          const allergens = item.FoodAllergens.map ( item => {
            return this.getAllergenFormatted(item)
          })
          body.push([utils.getTranslation(item.MenuName, this.locale), utils.getTranslation(item.FoodName, this.locale), utils.getTranslation(item.FoodIngredients, this.locale), item.FoodPrice, item.FoodVegan ? 'SI' : 'NO', item.FoodVegetarian ? 'SI' : 'NO',allergens])
        }
        // Or use javascript directly:
        doc.autoTable({
          head: [[i18n.t('dishes.menu'), i18n.t('dishes.food'), i18n.t('dishes.ingredients'), i18n.t('dishes.price'), i18n.t('dishes.vegan'), i18n.t('dishes.vegetarian'), i18n.t('dishes.allergens')]],
          body
          // body: [
          //   ['David', 'david@example.com', 'Sweden'],
          //   ['Castille', 'castille@example.com', 'Spain'],
          //   // ...
          // ],
        })

        doc.save('table.pdf')
      },
      handleChangePage () {
        this.getDishes()
      },
      handleChangeFilterSelected () {
        this.page = 1
        this.getDishes()
      }
    },
  }
</script>
